@if (activeUser$()) {
	<p-panel
		#ReAuthenticatePanel
		class="aura-light-blue"
	>
		<ng-template pTemplate="header">
			<div class="flex flex-col items-center">
				<!--		title-->
				<h3>{{ 'pages.login.re-authenticate-dialog.title' | translate }}</h3>
				<!--		sub-title-->
				<p>{{ 'pages.login.re-authenticate-dialog.sub-title' | translate }}</p>
			</div>
		</ng-template>

		<ng-template pTemplate="content">
			<mat-divider class="w-full mb-2" />
			<div class="flex flex-col space-y-2.5">
				<!--		username-->
				<p-inputGroup>
					<p-inputGroupAddon>
						<p-inputIcon styleClass="pi pi-user pi-fw"></p-inputIcon>
					</p-inputGroupAddon>

					<p-floatLabel class="w-full">
						<input
							id="username"
							type="text"
							pInputText
							[ngModel]="activeUser$()?.username"
							readonly
							disabled
						/>
						<label for="username">{{ 'pages.login.username' | translate }}</label>
					</p-floatLabel>
				</p-inputGroup>

				<!--		password-->
				<p-inputGroup>
					<p-inputGroupAddon>
						<p-inputIcon styleClass="pi pi-lock pi-fw"></p-inputIcon>
					</p-inputGroupAddon>

					<span class="p-float-label">
						<p-password
							styleClass="w-full h-full"
							id="password"
							[ngModel]="password$()"
							(ngModelChange)="password$.set($event)"
							[feedback]="false"
							pAutoFocus
							[autofocus]="true"
							(keyup.enter)="reAuthenticate()"
						/>
						<label for="password">{{ 'pages.login.password' | translate }}</label>
					</span>
				</p-inputGroup>

				<mat-divider class="w-full mb-2" />

				<!-- ------------------  Buttons ------------------ -->
				<div class="flex justify-between">
					<!--		cancel button-->
					<button
						pButton
						type="button"
						label="{{ 'pages.login.re-authenticate-dialog.cancel-btn' | translate }}"
						class="bg-gray-500 text-white font-bold"
						(click)="cancelReAuthenticate()"
					></button>

					<!--		submit button-->
					<button
						pButton
						type="button"
						label="{{ 'pages.login.re-authenticate-dialog.submit-btn' | translate }}"
						class="bg-primary-500 text-white font-bold"
						(click)="reAuthenticate()"
					></button>
				</div>
			</div>
		</ng-template>
	</p-panel>

	<p-blockUI
		[target]="ReAuthenticatePanel"
		[blocked]="inLoginProcess$()"
	>
		<i
			class="pi pi-lock"
			style="font-size: 3rem"
		></i>
	</p-blockUI>
}
